<template>
  <div class="table-title-column">
    <div
      v-for="title in titles"
      :key="title.dataIndex"
      class="table-title-column__cell"
    >

      <slot
        v-if="title.titleSlot"
        :name="`#${title.dataIndex}`"
        :title="title"
      ></slot>

      <div
        v-else
        v-html="title.name"
      ></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TableTitleColumn',
    props: {
      titles: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style lang="scss">
  .table-title-column {
    display: contents;
    color: transparentize($primary, 0.4);

    @media (max-width: $breakpoint-lg) {
      display: none;
    }
  }

  .table-title-column__cell {
    padding: 16px 16px 16px 0;

    &:not(:last-child) {
      border-bottom: 1px solid transparentize($primary, 0.9);
    }

    *:last-child {
      margin-bottom: 0;
    }
  }
</style>